module.exports = __webpack_public_path__ + "img/bell.d4b9a8c.svg";